// src/sections/ImagesDescription.jsx
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ImagesDescription = ({ contenuti }) => {
  // Trasforma l'oggetto in array di sezioni
  const sections = Array.isArray(contenuti)
    ? contenuti
    : Object.values(contenuti);

  return (
    <>
      {sections.map((section) => {
        const {
          ID,
          titolo_it,
          sottotitolo_it,
          descrizione_it,
          immagine_url,
          tema = {},
        } = section;

        const { classiCustom = 'flex-row', buttons = [], classText, classImage } = tema || {};

        return (
          <section key={ID} className="mb-5">
            <div
              className={`container d-flex ${classiCustom} align-items-stretch`}
            >

              <div className={`flex-shrink-0 ${classImage} image-covert`} style={{ width: '50%' }}>
                <img
                  src={immagine_url}
                  alt={titolo_it}
                  className="img-fluid w-100 h-100"
                  style={{ objectFit: 'cover' }}
                />
              </div>

              <div className={`flex-grow-1 p-4 ${classText}`}>
                {sottotitolo_it && (
                  <p className="text-12 mb-2">{sottotitolo_it}</p>
                )}
                {titolo_it && (
                  <h3 className="mb-3">{titolo_it}</h3>
                )}
                {descrizione_it && (
                  <p
                    className="mb-3 text-16 md-text-24"
                    dangerouslySetInnerHTML={{ __html: descrizione_it }}
                  />
                )}
                {buttons.length > 0 && (
                  <div className={`d-flex flex-wrap gap-2`}>
                    {buttons.map((btn, idx) => (
                      <a
                        key={idx}
                        href={btn.url}
                        className={`btn ${btn.class} text-16 md-text-21 p-2`}
                      >
                        {btn.text}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </section>
        );
      })}
    </>
  );
};

export default ImagesDescription;